var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconShort(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      enableBackground: "new 0 0 512 512"
    },
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "_x31_8_x2C__home_x2C__hygiene_x2C__prevent_x2C__protection_x2C__stay_home"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_15_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125,245v-35h280v35v200H125V245z",
    id: "XMLID_69_",
    style: {
      fill: "#D0DCE7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75,355c13.81,0,25,11.19,25,25s-11.19,25-25,25s-25-11.19-25-25S61.19,355,75,355z    ",
    id: "XMLID_66_",
    style: {
      fill: "#D94556"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 435,
    cy: 90,
    id: "XMLID_63_",
    r: 35,
    style: {
      fill: "#D94556"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.96,389.64c8.25,13.23-1.27,30.36-16.85,30.36H176.24    c-15.59,0-25.1-17.13-16.86-30.36l89.44-143.57c7.77-12.48,25.94-12.48,33.71,0L371.96,389.64z",
    id: "XMLID_57_",
    style: {
      fill: "#3F4751"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.99,377.73c2.39,2.39,3.86,5.68,3.86,9.319c0,3.641-1.47,6.931-3.86,9.32    c-2.39,2.39-5.68,3.86-9.32,3.86c-7.27,0-13.18-5.9-13.18-13.181c0-3.64,1.48-6.93,3.86-9.319c2.39-2.391,5.69-3.86,9.32-3.86    C269.31,373.87,272.6,375.34,274.99,377.73z",
    id: "XMLID_54_",
    style: {
      fill: "#FFD400"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.85,288.21v56.01c0,7.28-5.9,13.181-13.18,13.181    c-7.27,0-13.18-5.9-13.18-13.181v-56.01c0-7.28,5.91-13.18,13.18-13.18c3.64,0,6.93,1.47,9.32,3.859    C277.38,281.28,278.85,284.57,278.85,288.21z",
    id: "XMLID_51_",
    style: {
      fill: "#FFD400"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170,140l0.11,0.17l-39.53,25.07l-0.58-0.92V125c0-5.52,2.24-10.52,5.86-14.14    c3.62-3.62,8.62-5.86,14.14-5.86c11.05,0,20,8.95,20,20V140z",
    id: "XMLID_48_",
    style: {
      fill: "#D94556"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_45_",
    points: "465,210 405,210 125,210 60,210 130.58,165.24 170.11,140.17 265,80   ",
    style: {
      fill: "#757D8C"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 467.5,
    cy: 162.5,
    id: "XMLID_44_",
    r: 7.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 442.5,
    cy: 317.5,
    id: "XMLID_43_",
    r: 7.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 337.5,
    cy: 47.5,
    id: "XMLID_42_",
    r: 7.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 327.5,
    cy: 472.5,
    id: "XMLID_41_",
    r: 7.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 137.5,
    cy: 72.5,
    id: "XMLID_40_",
    r: 7.5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.5,
    cy: 297.5,
    id: "XMLID_39_",
    r: 7.5
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 162.5,
    id: "XMLID_38_",
    r: 7.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M405,450H125c-2.761,0-5-2.238-5-5V210c0-2.761,2.239-5,5-5s5,2.239,5,5v230h270V210c0-2.761,2.239-5,5-5    s5,2.239,5,5v235C410,447.762,407.761,450,405,450z",
    id: "XMLID_37_"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M265.67,362.4c-10.024,0-18.18-8.156-18.18-18.181v-56.01c0-10.025,8.155-18.18,18.18-18.18    c4.857,0,9.422,1.891,12.855,5.323c3.434,3.436,5.325,8.001,5.325,12.857v56.01C283.85,354.244,275.694,362.4,265.67,362.4z     M265.67,280.03c-4.51,0-8.18,3.669-8.18,8.18v56.01c0,4.511,3.669,8.181,8.18,8.181c4.511,0,8.18-3.67,8.18-8.181v-56.01    c0-2.185-0.851-4.239-2.396-5.785C269.91,280.881,267.855,280.03,265.67,280.03z",
    id: "XMLID_34_"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M265.67,405.23c-10.024,0-18.18-8.156-18.18-18.181c0-4.842,1.888-9.404,5.317-12.848    c3.44-3.44,8.006-5.332,12.863-5.332c4.857,0,9.423,1.892,12.856,5.325c3.433,3.433,5.324,7.998,5.324,12.854    c0,4.857-1.891,9.423-5.324,12.855C275.091,403.34,270.526,405.23,265.67,405.23z M265.67,378.87    c-2.185,0-4.239,0.851-5.784,2.396c-1.542,1.549-2.396,3.605-2.396,5.784c0,4.511,3.669,8.181,8.18,8.181    c2.185,0,4.24-0.851,5.785-2.396c1.544-1.544,2.395-3.599,2.395-5.784c0-2.185-0.851-4.239-2.396-5.784    C269.91,379.721,267.855,378.87,265.67,378.87z",
    id: "XMLID_31_"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M355.11,425H176.24c-9.164,0-17.29-4.782-21.738-12.791c-4.447-8.01-4.21-17.435,0.633-25.213    l89.441-143.57c4.567-7.336,12.455-11.716,21.099-11.716c8.644,0,16.532,4.38,21.1,11.717l89.43,143.569    c4.847,7.772,5.087,17.196,0.642,25.206C372.399,420.216,364.273,425,355.11,425z M265.675,241.71    c-5.166,0-9.88,2.618-12.61,7.002l-89.441,143.571c-2.895,4.649-3.037,10.283-0.378,15.071c2.659,4.787,7.517,7.646,12.995,7.646    h178.87c5.477,0,10.334-2.859,12.992-7.649c2.656-4.787,2.513-10.419-0.385-15.065l-89.432-143.572    C275.555,244.328,270.841,241.71,265.675,241.71z",
    id: "XMLID_28_"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M435,130c-22.056,0-40-17.944-40-40s17.944-40,40-40s40,17.944,40,40S457.056,130,435,130z M435,60    c-16.542,0-30,13.458-30,30s13.458,30,30,30s30-13.458,30-30S451.542,60,435,60z",
    id: "XMLID_25_"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75,410c-16.542,0-30-13.458-30-30s13.458-30,30-30s30,13.458,30,30S91.542,410,75,410z M75,360    c-11.028,0-20,8.972-20,20s8.972,20,20,20s20-8.972,20-20S86.028,360,75,360z",
    id: "XMLID_22_"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M130,169.32c-2.761,0-5-2.239-5-5V125c0-6.674,2.601-12.952,7.324-17.675    C137.048,102.601,143.326,100,150,100c13.785,0,25,11.215,25,25v15c0,2.761-2.239,5-5,5s-5-2.239-5-5v-15c0-8.271-6.729-15-15-15    c-4.004,0-7.77,1.561-10.605,4.396C136.561,117.23,135,120.996,135,125v39.32C135,167.081,132.761,169.32,130,169.32z",
    id: "XMLID_21_"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M465.02,215c-0.007,0-0.014-0.001-0.02,0H60c-2.225,0-4.182-1.47-4.802-3.606    c-0.62-2.136,0.246-4.425,2.124-5.617l205-130c1.653-1.048,3.763-1.035,5.403,0.03l199.726,129.822    c1.533,0.855,2.569,2.492,2.569,4.371C470.02,212.761,467.781,215,465.02,215z M77.22,205h370.913L264.967,85.942L77.22,205z",
    id: "XMLID_18_"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M405,250h-85c-2.761,0-5-2.239-5-5s2.239-5,5-5h85c2.761,0,5,2.239,5,5S407.761,250,405,250z",
    id: "XMLID_17_"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M210,250h-85c-2.761,0-5-2.239-5-5s2.239-5,5-5h85c2.761,0,5,2.239,5,5S212.761,250,210,250z",
    id: "XMLID_16_"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShort);
export default __webpack_public_path__ + "static/media/icon-short.b267e349f2943c1b7f8a1a373ff22253.svg";
export { ForwardRef as ReactComponent };